import { render } from "./FinancialDetailsPage.vue?vue&type=template&id=597c9e50&ts=true"
import script from "./FinancialDetailsPage.vue?vue&type=script&lang=ts"
export * from "./FinancialDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__